<div class="ctr">
  <p class="top" [innerHTML]="getTitleText()" [style.fontSize]="TitleTextFontSize.toString() + 'px'" ></p>
  <div class="divider"></div>
  <p class="bottom" [innerHTML]="getBodyText()" [style.fontSize]="BodyTextFontSize.toString() + 'px'"
    [style.lineHeight]="(BodyTextFontSize*1.18) + 'px'"
  ></p>
</div>
